import React from "react";
import { useMutation, useQuery } from "react-query";
import { getPromo, newClick } from "../../hooks/promo";

const promoId = "cls3c507a000094ah8htsga4h";

const Promo = () => {
  const { data: promo, isLoading } = useQuery(["promo"], () => getPromo(promoId));
  const { mutate } = useMutation(["click"], (variables) => newClick(variables), {});

  if (isLoading) return <div>Loading promo...</div>;

  function handlePromo() {
    window.open(`${promo.link}`, "_blank");
  }

  function handleClick() {
    handlePromo();
    const variables = { type: "PROMO" };
    return mutate({ variables });
  }

  return (
    <div className="hero-block">
      <img src={`${promo.image}`} className="hero-block-img" alt="promo" />
      {/* <span className="hero-mask" /> */}
      <h1 className="hero-block-title">{promo.title.toUpperCase()}</h1>
      <button className="hero-block-btn" onClick={() => handleClick()}>
        {promo.button.toUpperCase()}
      </button>
      <p className="hero-block-desc">{promo.description}</p>
    </div>
  );
};

export default Promo;
